import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";

import OurProjects from "../../components/project/ourproject";
import { PlotsAdvantages } from "../../components/plots/plots";
import SliderVideo from "../../components/sliders/vsliders";

import ProjectTabs from "../../components/project_tabs/projectTab";
import Banner from "../../components/header/banner";
import HomeBanner from "../../assets/images/sangamam_1.jpg";
import HomeBanner2 from "../../assets/images/cove_2.jpg";
import HomeBanner4 from "../../assets/images/home_ban_1.jpeg";
import HomeBanner5 from "../../assets/images/home_ban_2.jpeg";
import HomeBanner6 from "../../assets/images/home_ban_3.jpeg";
// import HomeBanner3 from "../../assets/images/home_banner.png";
/* ---- */
/* ----- */
import HomeEnquiryPopup from "../home/homeEnquiryPopup";

export default function UtsavPage() {
  return (
    <div>
      <HomeEnquiryPopup />
      <Banner
        bannerImages={[
          HomeBanner,
          HomeBanner2,
          HomeBanner4,
          HomeBanner5,
          HomeBanner6,
        ]}
        showForm={false}
      />
      <OurProjects />
      <PlotsAdvantages />
      <SliderVideo />
      <ProjectTabs />
    </div>
  );
}
